import { useAppContext } from '@/Main';
import { changeBgColor } from '@/utils/pre-load/changeBgColor';
import type { CSSProperties, ReactNode } from 'react';

type SemiCircleChartSkeletonProps = {
  title?: ReactNode;
  tooltip?: ReactNode;
  minHeight?: CSSProperties['minHeight'];
  styles?: CSSProperties;
};

const SemiCircleChartSkeleton = ({
  minHeight = '200px',
  styles = {
    borderRadius: '12rem 12rem 0 0',
    width: '60%',
    height: '150px',
    margin: '32px 0 32px 0'
  }
}: SemiCircleChartSkeletonProps) => {
  const {
    config: { theme }
  } = useAppContext();
  return (
    <>
      <div className="chart_loading_wrapper" style={{ minHeight }}>
        <div>
          <div style={styles} className="circle_chart_loading"></div>
        </div>
      </div>
      <style>
        {`
            .circle_chart_loading{
                background:${changeBgColor(theme)};
                background-size: 200% 100%;
                background-position: 100% 0;
            }
        `}
      </style>
    </>
  );
};

export default SemiCircleChartSkeleton;
